import { createSlice } from '@reduxjs/toolkit';

const groomers = createSlice({
  name: 'groomers',
  initialState: {
    groomers: [],
    selectedGroomer: null,
  },
  reducers: {
    teamUsersRequest(state) {
      state.isLoading = true;
    },
    teamUsersSuccess(state, { payload }) {
      state.isLoading = false;
      state.groomers = payload.data;
    },
    teamUsersFailure(state) {
      state.isLoading = false;
    },
    teamUserServicesRequest(state) {
      state.isLoading = true;
    },
    teamUserServicesSuccess(state, { payload }) {
      const { user, services } = payload.data;

      const updatedGroomers = state.groomers.map((groomer) => {
        if (groomer.user.uuid === user.uuid) {
          return { ...groomer, services };
        } else return groomer;
      });
      state.groomers = updatedGroomers;
      state.isLoading = false;
    },
    teamUserServicesFailure(state) {
      state.isLoading = false;
    },
  },
});

const { actions, reducer } = groomers;

export const {
  teamUsersRequest,
  teamUsersSuccess,
  teamUsersFailure,
  teamUserServicesRequest,
  teamUserServicesSuccess,
  teamUserServicesFailure,
} = actions;

export default reducer;
